import React from 'react';
import { useSelector } from 'react-redux';

import { isEmpty } from '../../helpers/utils';
import { Container } from './DemoInteractionBlocker';

export interface IMultimediaInteractionBlockerProps {}

export function MultimediaInteractionBlocker(
  props: IMultimediaInteractionBlockerProps
) {
  const context = useSelector((state: any) => state.executor.context);
  const multimedia = useSelector((state: any) => state.executor.multimediaText);
  if (context?.mode !== 'demo' && !isEmpty(multimedia)) {
    return <Container data-blocker="multimediablocker"></Container>;
  }
  return <></>;
}
